/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { geocodeByPlaceId, getLatLng } from 'react-places-autocomplete';
import { focusMap, showAutocompleteError } from '@actions/map-actions';
import DmListItem from '@components/shared/ui-library/list/dm-list-item';
import { highlightTerm } from '@utils/shared-utils';
import styles from './google-item.scss';

const GoogleItem = ({ prediction }) => {
  const dispatch = useDispatch();
  const term = useSelector(state => state.map.traySearch.term);
  const markerItem = useSelector(state => state.map.viewport.markerItem);

  const onClick = useCallback(() => {
    const { place_id: placeId, description } = prediction;
    geocodeByPlaceId(placeId)
      .then(results => getLatLng(results[0]))
      .then(center => dispatch(focusMap(center, description)))
      .catch(error => dispatch(showAutocompleteError(error)));
  }, [dispatch, prediction]);

  const { description } = prediction;
  const text = highlightTerm(description, term);

  return (
    <DmListItem
      className={classNames(
        styles.googleItem,
        {
          [styles.googleItemActive]: markerItem === description
        }
      )}
      onClick={onClick}
    >
      <span className={styles.label}>
        {text}
      </span>
    </DmListItem>
  );
};

GoogleItem.propTypes = {
  prediction: PropTypes.object
};

export default memo(GoogleItem);
